// Third party import
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IInviteUserState {
  isDrawerOpen: boolean;
  currentPage: number;
  currentReportingPage: number;
  callOfUsers: boolean;
  callOfReportingUsers: boolean;
  callFilterDivisionList: boolean;
}

const initialState: IInviteUserState = {
  isDrawerOpen: false,
  currentPage: 1,
  currentReportingPage: 1,
  callOfUsers: false,
  callOfReportingUsers: false,
  callFilterDivisionList: true};

export const inviteUserSlice = createSlice({
  name: "addNewUser",
  initialState,
  reducers: {
    setIsDrawerOpen: (
      state: { isDrawerOpen: boolean },
      action: PayloadAction<boolean>
    ) => {
      state.isDrawerOpen = action.payload;
    },
    setCurrentPage: (
      state: { currentPage: number },
      action: PayloadAction<number>
    ) => {
      state.currentPage = action.payload;
    },
    setCurrentReportingPage: (
      state: { currentReportingPage: number },
      action: PayloadAction<number>
    ) => {
      state.currentReportingPage = action.payload;
    },
    setCallOfUsers: (
      state: { callOfUsers: boolean },
      action: PayloadAction<boolean>
    ) => {
      state.callOfUsers = action.payload;
    },
    setCallOfReportingUsers: (
      state: { callOfReportingUsers: boolean },
      action: PayloadAction<boolean>
    ) => {
      state.callOfReportingUsers = action.payload;
    },
    setCallFilterDivisionList: (
      state: { callFilterDivisionList: boolean },
      action: PayloadAction<boolean>
    ) => {
      state.callFilterDivisionList = action.payload;
    }}});

export const {
  setIsDrawerOpen,
  setCurrentPage,
  setCurrentReportingPage,
  setCallOfReportingUsers,
  setCallOfUsers,
  setCallFilterDivisionList} = inviteUserSlice.actions;

export default inviteUserSlice.reducer;
